export enum ProviderRole {
  PRIMARY = 'PRIMARY',
  SPECIALIST = 'SPECIALIST',
  HOSPITAL = 'HOSPITAL',
}
